
/*
var form = {
	'title': method.title,
	'prompt': method.prompt,
	'btn': method.title,
	'templateUrl': method.templateUrl || null,  // used in form-service
	'submit': function(data) { ... }       // returns a promise
	'params': [{
		'title': 'Login',
		'type': 'Field',
		'name': 'login'
		'groups': ['edit'],
		?'required': false,
		?'default': 'name + "12"',
		?'redefault_on': 'never' | 'depends&always' | 'depends&unedited'
		'visible': 'userId == 1',
		'editable': 'true',
		?'dictionary': [['1', 'One'], ['2', 'Two']],
		?'depends': 'first_name',
		...  --  field functions like dict()
	}, ... ],
	'layout': ['edit'],
	'options': { anything },
	'modalOptions': {} // $modal options  - special for activateFormModal
}
*/

function Form(config, values, $rootScope, $q) {

    var self = this;
    this.message = null;
    this.is_busy = false;
    this.is_completed = false;

    this.field_errors = null;
    this.values = values;
	this.fieldStates = {}
	
	self.config = {
		layout: config.layout || ['edit'],
		title: config.title,
		prompt: config.prompt,
		btn: config.btn || 'OK',
		templateUrl: config.templateUrl,
		params: config.params || [],
		submit: config.submit,
		options: config.options,  // addtional options
	}

    this.submit = function(){
		if (this.is_busy) return;
		this.message = null;
		this.is_busy = true;
		var combined_state = this.getFieldCombinedState();
		if (combined_state.busy) {
			self.is_busy = false;
			self.message = {type: 'warning', body: 'Some fields are busy. Wait for the work to finish.'};
			return $q.reject({data:{message:self.message.body}});
		}
		if (combined_state.invalid) {
			self.is_busy = false;
			self.message = {type: 'warning', body: 'Form field values were entered incorrectly'};
			return $q.reject({data:{message:self.message.body}});
		}
		return this.config.submit(this.values).then(function(result){
			// success
			console.log("Form result:", result);
			self.is_busy = false;
            self.is_completed = true;
			if (result && result.__callstatus && result.__callstatus.message) {
				self.message = {type: 'info', body: result.__callstatus.message, parameters: result.__callstatus.message_parameters};
			}
			return result;
		},function(data, status, headers, config){
			// failure
			console.debug('Form error', data.data);
			self.is_busy = false;
			if (typeof data.data == "string") {
				self.field_errors = null;
				self.message = {type: 'danger', body: 'HTTP error: ' + data.statusText}
			} else {
				self.message = {type: 'warning', body: data.data.message};
				self.field_errors = data.data.data;
				if (data.data.code == 401) {
					$rootScope.$broadcast('unauthorized');
				}
			}
			return $q.reject(data);
		});
		
	}; // end submit

	this.reset = function(values) {
		this.message = null;
    	this.is_busy = false;
    	this.is_completed = false;
   		this.field_errors = null;
    	angular.extend(this.values, values);
	}

	this.setFieldState = function(id, field, state, message) {
		console.log(field.title + ' state set to: ' + state, message);
		if (state === null) {
			if (this.fieldStates[id]) {
				delete this.fieldStates[id];
			}
		} else {
			this.fieldStates[id] = {field:field, state:state, message:message}
		}
	}

	this.getFieldCombinedState = function() {
		var state = {busy: false, invalid: false};
		for (var id in this.fieldStates) {
			if (this.fieldStates[id].state != 'valid') {
				state[this.fieldStates[id].state] = true;
			}
		}
		return state;
	}
}

angular.module('forms')

.config(function($uibModalProvider){
	$uibModalProvider.options.size = 'lg';
	
})

.service('FormService', function($injector, $parse, Classes, CurrentUser, $q, $uibModal){

    var self = this;
    
    this.createForm = function(config, values) {
        return $injector.instantiate(Form, {config:config, values:values});
    }

	this.fetchDefaultInstance = function(fields, defaults) {
		var defaults = defaults || {};
		for (var k in fields) {
    		var field = fields[k];
			if (field && typeof field['default'] != "undefined" && typeof defaults[field['name']] == "undefined") {
				var func = $parse(field['default']);  // function(context, locals)
				defaults[field['name']] = func({$moment: moment, $user: CurrentUser.instance}, Classes); 
			}
    	}
    	return $q.all(defaults);
	}

	this.activateFormModal = function(formconfig, defaults) {
		var defaults = defaults || {}
		var modalOptions = formconfig.modalOptions || {}
		modalOptions.controller = 'modalFormCtrl as $ctrl';
		modalOptions.templateUrl = formconfig.templateUrl || 'framework/partials/admin/form-modal.html';
		modalOptions.resolve = {
			formconfig: function(){return formconfig},
			values: function(){
				// setup field values so all params are present even if empty 
				// evaluates default parameters (supports promises)
				return self.fetchDefaultInstance(formconfig.params, defaults)
			},
		}
		var dlg = $uibModal.open(modalOptions);
		return dlg.result;
	}

	


})



.service('FormNewInstanceFactory', function($injector, $parse, CurrentUser, Classes){
	this.ContextService = null;
	if ($injector.has('ContextService')) {
		this.ContextService = $injector.get('ContextService');
	}

	this.fetchNewInstance = function(classname, defaults) {
		if (this.ContextService) {
			return this.newInstanceFromContext(classname, defaults)
		} else {
			return this.newInstanceFromClass(classname, defaults)
		}
	}

	// this function is called when admin is not loaded
	this.newInstanceFromClass = function(classname, defaults) {
		defaults = defaults || {}
		var klass = Classes[classname]
		if (!klass) {
			throw "FormNewInstanceFactory: No class defined for: " + classname
		}
		return this.fetchClassDefaults().then(function(class_defaults){
			var data = angular.extend({}, class_defaults, defaults);
			var object = klass.create(data)
			return object;
		})
	}

	// this function is called when admin is active and configured
	// some additional default values might be available depending on context
	this.newInstanceFromContext = function(classname, defaults) {
		var module = this.ContextService.getContext(classname);
		return module.fetchNewInstance(defaults)
	}

	this.fetchClassDefaults = function(klass) {
		var defaults = {};
		var fields = klass.get_form_params();    // was: cls.fields
		for (var k in fields) {
    		var field = fields[k];
			if (field && typeof field['default'] != "undefined") {
				var func = $parse(field['default']);  // function(context, locals)
				defaults[field['name']] = func({$moment: moment, $user: CurrentUser.instance}, Classes); 
			}
    	}
    	return $q.all(defaults);
	}
})



.controller('modalFormCtrl',function($scope, $uibModalInstance, $q, $translate, dialogs, FormService, formconfig, values){
	//-- Variables --//

	var self = this;
	this.form = FormService.createForm(formconfig, values);

	window.modalFormCtrl = this;
	window.$modalFormScope = $scope;
	
	//-- Methods --//
	
	this.cancel = function(){
		$uibModalInstance.dismiss(null);
	}; // end cancel
	
	this.submit = function(){
		if (this.form.is_busy) return;
		this.form.submit().then(function(result){
			// success
			$uibModalInstance.close(result);
			if (result && result.__callstatus && result.__callstatus.message) {
				dialogs.notify($translate.instant(self.form.title), $translate.instant(result.__callstatus.message, result.__callstatus.message_parameters));
			}
		});
	}; // end submit
	
	$scope.$on('submitonenter', function(){
		self.submit();
	});

	
})




